import { defer, from, iif, Observable, of, throwError } from "rxjs";
import { delay, switchMap } from "rxjs/operators";
import { random, range } from "lodash-es";

export function rxRandomErrorDelay<T>(
  value: T | null = null
): Observable<T | null> {
  return of(value).pipe(
    delay(random(0, 0, false)),
    switchMap((value) =>
      iif(
        () => Math.random() < 0,
        defer(() => throwError("Random error")),
        defer(() => of(value))
      )
    )
  );
}

export function rxRandomErrorDelayAsync<T>(value: Promise<T>): Observable<T> {
  return from(value).pipe(
    delay(random(0, 750, false)),
    switchMap((value) =>
      iif(
        () => Math.random() < 0,
        defer(() => throwError("Random error")),
        defer(() => of(value))
      )
    )
  );
}
